import { useEffect, useState } from 'react';
import CustomBlockButton from '../../../components/button/CustomBlockButton';
import { CustomInput } from '../../../components/input/CustomInput';
import * as St from './index.styled';
import { redirect, useNavigate } from 'react-router-dom';
import { useUserPageContextActionsHook, useUserPageContextValueHook } from '../../../contexts/UserPageContextProvider';
import { useAuthContextValueHook } from '@/contexts/AuthContext';
import { useCreateUserPageMutation, useUserPageQuery } from '@/hooks/ReactQuery/UserPageReactQuery/UserPageReactQuery';
import { customToast } from '@/components/toast/custom-react-toastify/v1';

export function MainView(props) {
    const navigate = useNavigate();

    const authContextValueHook = useAuthContextValueHook();

    const userPageContextActionsHook = useUserPageContextActionsHook();

    const { data: userPageData, isLoading: userPageDataIsLoading } = useUserPageQuery({
        isLoggedIn: authContextValueHook?.isLoggedIn,
        isReady: authContextValueHook?.isReady,
        accessToken: authContextValueHook?.accessToken
    });
    const userPage = userPageData?.data?.content;
    const createUserPageMutation = useCreateUserPageMutation();

    const [domainName, setDomainName] = useState('');

    useEffect(() => {
        if (!authContextValueHook?.isLoggedIn && !authContextValueHook?.isReady) {
            navigate('/login', { replace: true })
        }
    }, [authContextValueHook?.isLoggedIn, authContextValueHook?.isReady]);

    useEffect(() => {
        if (!userPageDataIsLoading && userPage) {

            navigate(`/mypage/${userPageData?.data?.content?.id}`, { replace: true })
            return;
        }
    }, [userPage, userPageDataIsLoading])


    const handleChangeDomainNameFromEvent = (e) => {
        let value = e.target.value;

        if (value?.length > 20) {
            return;
        }

        setDomainName(value);
    }

    const handleReqCreateUserPage = async (e) => {
        e.preventDefault();

        let regex = /^[a-z_0-9]{3,20}$/
        if (!regex.test(domainName)) {
            alert('3~20자 내외 영문 소문자[a-z], 숫자[0-9], underscore[_] 특수문자만 허용 됩니다.');
            return;
        }

        let body = {
            domainName: domainName
        }

        createUserPageMutation.mutate({
            body: body
        }, {
            onSuccess: (data) => {
                if (data?.data?.content) {
                    userPageContextActionsHook.onSetUserPage({
                        ...data?.data?.content
                    })
                    customToast.success('마이 페이지가 생성되었습니다!!')
                    navigate(`/mypage/${data?.data?.content?.id}`, { replace: true });
                }
            }
        })
    }

    if (!authContextValueHook?.isReady || userPageDataIsLoading || userPage) {
        return null;
    }

    return (
        <>
            <div className="min-h-screen bg-[#f5f5f7] px-3 pb-24 pt-8 sm:pt-16">
            <St.Container>
                <form onSubmit={(e) => handleReqCreateUserPage(e)}>
                    <St.Wrapper>
                        <St.IntroduceWrapper>
                            <div className='mainDescription'>지금 바로 마이 페이지를 생성해 보세요!</div>
                            <div className='subDescription'>마이 페이지를 생성하고 여러 링크를 공유해 보세요.</div>
                        </St.IntroduceWrapper>
                        <St.InputGroupWrapper>
                            <div className='inputBox'>
                                <CustomInput
                                    type='text'
                                    value={domainName || ''}
                                    onChange={(e) => handleChangeDomainNameFromEvent(e)}
                                    placeholder='페이지 도메인'
                                />
                                <label className='footerLabel'>3~20자 내외 영문 소문자[a-z], 숫자[0-9], underscore[_] 특수문자만 허용 됩니다.</label>
                            </div>
                        </St.InputGroupWrapper>
                        <St.FooterButtonGroup>
                            <CustomBlockButton>페이지 생성</CustomBlockButton>
                        </St.FooterButtonGroup>
                    </St.Wrapper>
                </form>
            </St.Container>
            </div>
        </>
    );
}